// extracted by mini-css-extract-plugin
export default {"input-container":"input_input-container__fE+3e","label":"input_label__yGO9K","labelReq":"input_labelReq__yZm4j","input":"input_input__FWpqx"};